import React from "react";
import Icon from "@irati/ui/src/Icon";
import { IconWrapper } from "./styled";
var TemplateIcon = function (_a) {
    var icon = _a.icon;
    return (React.createElement(IconWrapper, null,
        React.createElement(Icon, { icon: icon, size: "26" })));
};
export default TemplateIcon;
